var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { accessTokenPresent, getCurrentAccessLevel, getCurrentUserId, } from './credentials';
import { UPDATE_SESSION } from './types';
var initialState = {
    accessLevel: getCurrentAccessLevel(),
    isAuthenticated: accessTokenPresent(),
    sessionInvalidated: false,
    userId: getCurrentUserId(),
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_SESSION: {
            return __assign(__assign({}, state), action.payload);
        }
        default:
            return state;
    }
}
